/** @jsxRuntime classic */
/** @jsx jsx */

import { Fragment, useMemo } from 'react';
import { jsx } from '@emotion/react';
import { spaceColumnContainer, spaceRowContainer } from '../../styles';
import { ECalendarView, IResource, IWeeklyViewProps } from '../../types';
import { WeekToDrop } from './WeekToDrop';
import { useMiddlewareContext } from '../../hooks/useMiddlewareContext';
import { sumBy } from 'lodash';
import { useResources } from '../../hooks/useResources';

export const WeeklyView = ({ EventComponent, isLoading, resourceGroups }: IWeeklyViewProps) => {
	const { options } = useMiddlewareContext();
	const { view = ECalendarView.VERTICAL } = options || {};
	const horizontal = view === ECalendarView.HORIZONTAL;

	const { resources, columnsCount } = useResources({ resourceGroups });

	return (
		<Fragment>
			{resources?.map(resource => {
				const currentChildrenLength = resource.children?.length;
				const weeklyContainerCss = horizontal
					? spaceRowContainer
					: spaceColumnContainer(columnsCount, currentChildrenLength || 1);
				return (
					<div key={resource.id} css={weeklyContainerCss} data-aid="WeeklyView-weekly">
						{currentChildrenLength === 0 ? (
							<WeekToDrop
								key={resource.id}
								resourceId={String(resource.id)}
								EventComponent={EventComponent}
								isLoading={isLoading}
							/>
						) : (
							resource.children.map(item => (
								<WeekToDrop
									key={item.id}
									resourceId={String(item.id)}
									EventComponent={EventComponent}
									isLoading={isLoading}
								/>
							))
						)}
					</div>
				);
			})}
		</Fragment>
	);
};
